/**
 * AppShell — sidebar + header chrome for full-page routes that live OUTSIDE the
 * workspace panel system (e.g. /backtests/:runId, /plans/:planId). It renders
 * the same Sidebar + Header as WorkspaceLayout but deliberately omits the
 * URL↔workspace-store sync, which would otherwise fight these dedicated routes.
 */
import { Outlet } from 'react-router-dom'
import { useSettingsStore } from '@/stores/settingsStore'
import { cn } from '@/lib/utils'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Sidebar } from '@/components/layout/Sidebar'
import { Header } from '@/components/layout/Header'
import { useIsMobile } from '@/hooks/useIsMobile'

export function AppShell() {
  const isMobile = useIsMobile()
  const sidebarCollapsed = useSettingsStore((s) => s.sidebarCollapsed)
  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex h-full bg-background text-foreground">
        {!isMobile && <Sidebar />}
        <div
          className={cn(
            'flex flex-1 min-w-0 flex-col transition-all duration-200',
            !isMobile && (sidebarCollapsed ? 'ml-16' : 'ml-56'),
          )}
        >
          <Header isMobile={isMobile} />
          <main className="flex-1 min-h-0 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </TooltipProvider>
  )
}
